import { FC, useEffect, useState } from 'react';
import { ProjectCardLayout } from './projectCardLayout';
import { Colors, FInter, useToasts } from '@brg/ui';
import { useHistory } from 'react-router-dom';
import { ProjectDesignerName } from '../projectDesignerName';
import { IProjectLight } from '../../common';
import { LikesBox } from '../likesBox';
import { ProjectCardTitle } from './styles';
import { ProjectCardTools } from './ProjectCardTools';
import { ProjectEvents } from '../../helpers/projectEvents';
import { createCopyLinkProjectFn } from '../../helpers/copyLink';
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { CreateLinkTo } from '../../constants/linkTo';
import {API, LikeAPI, LikeObject, Project} from '@brg/api';
import i18next from 'i18next';
import {useTranslation} from "react-i18next";

export interface ProjectCardProps extends Partial<IProjectLight>, ProjectEvents {
    isLoading?: boolean;
    isEditable?: boolean;
    isSelectable?: boolean;
    tooltip?: ProjectTooltipProps;
    width?: string;
    height?: string;
    onShouldReload?: (sender: any) => void;
    onProjectClick?: (projectId: string) => void;
    onSelect?: (projectId: string) => void;
    onApprove?: (projectId: string) => void;
    onReject?: (projectId: string) => void;
    selected?: boolean;
    project?: Project;
    rank?: number;
    useDirectNavigation?: boolean;
    metaAlwaysVisible?: boolean;
    openInModal?: boolean;
}

export const ProjectCard: FC<ProjectCardProps> = (props) => {
    const {
        isLoading,
        image,
        identifier,
        title,
        likes,
        authors,
        author,
        coAuthors,
        isLiked,
        isEditable,
        tooltip,
        width,
        height,
        ...handlers
    } = props;
    const history = useHistory();
    const toasts = useToasts();
    const { t } = useTranslation();

    const onProjectClick = (projectId: string, ev: any): void => {
        if (ev.ctrlKey || ev.metaKey) window.open(CreateLinkTo.project(projectId), '_blank');
        else history.push(CreateLinkTo.project(projectId));
    };
    const onDesignerSelected = (designerId: string): void => history.push(CreateLinkTo.designer(designerId));

    const [rawLikes, setRawLikes] = useState(0);
    const [rawIsLiked, setRawIsLiked] = useState(false);

    useEffect(() => {
        if (identifier) {
            LikeAPI.GetLike({ entityId: identifier, entityType: 'project' })
                .then((v) => v.json())
                .then((v) => API.toLang<LikeObject>(v, i18next.language))
                .then((v) => {
                    setRawIsLiked(v.isLike);
                    setRawLikes(v.countLike);
                });
        }
    }, [identifier]);

    return (
        <ProjectCardLayout
            identifier={identifier}
            onClick={onProjectClick}
            img={image}
            isLoading={isLoading}
            width={width}
            height={height}
            href={CreateLinkTo.project(identifier ?? '')}
            // Заголовок карточки
            title={<ProjectCardTitle>{title}</ProjectCardTitle>}
            isMoreVisible={isEditable}
            more={
                <ProjectCardTools
                    {...handlers}
                    isHiddenCancel={true}
                    isCanBeDraft={true}
                    identifier={identifier}
                    isEditable={true}
                    isCopyLink={true}
                    onCopyLink={createCopyLinkProjectFn(toasts, t)}
                    {...(tooltip ?? {})}
                />
            }
            // Отображение одного и множественных авторов
            author={
                <FInter.SmallText color={Colors.geoWhite47}>
                    <ProjectDesignerName value={author ? [author].concat(coAuthors ?? []) : (coAuthors ?? [])} onSelected={onDesignerSelected} />
                </FInter.SmallText>
            }
            // Лайки, но только отображение
            likes={<LikesBox likes={rawLikes} isLiked={rawIsLiked} isInteractive={false} />}
        />
    );
};
import { FC, useEffect, useState } from 'react';
import { ProjectCardLayout } from './projectCardLayout';
import { Colors, FInter, useToasts } from '@brg/ui';
import { useHistory } from 'react-router-dom';
import { ProjectDesignerName } from '../projectDesignerName';
import { IProjectLight } from '../../common';
import { LikesBox } from '../likesBox';
import { ProjectCardTitle } from './styles';
import { ProjectCardTools } from './ProjectCardTools';
import { ProjectEvents } from '../../helpers/projectEvents';
import { createCopyLinkProjectFn } from '../../helpers/copyLink';
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { CreateLinkTo } from '../../constants/linkTo';
import {API, LikeAPI, LikeObject, Project} from '@brg/api';
import i18next from 'i18next';
import {useTranslation} from "react-i18next";

export interface ProjectCardProps extends Partial<IProjectLight>, ProjectEvents {
    isLoading?: boolean;
    isEditable?: boolean;
    isSelectable?: boolean;
    tooltip?: ProjectTooltipProps;
    width?: string;
    height?: string;
    onShouldReload?: (sender: any) => void;
    onProjectClick?: (projectId: string) => void;
    onSelect?: (projectId: string) => void;
    onApprove?: (projectId: string) => void;
    onReject?: (projectId: string) => void;
    selected?: boolean;
    project?: Project;
    rank?: number;
    useDirectNavigation?: boolean;
    metaAlwaysVisible?: boolean;
    openInModal?: boolean;
}

export const ProjectCard: FC<ProjectCardProps> = (props) => {
    const {
        isLoading,
        image,
        identifier,
        title,
        likes,
        authors,
        author,
        coAuthors,
        isLiked,
        isEditable,
        tooltip,
        width,
        height,
        ...handlers
    } = props;
    const history = useHistory();
    const toasts = useToasts();
    const { t } = useTranslation();

    const onProjectClick = (projectId: string, ev: any): void => {
        if (ev.ctrlKey || ev.metaKey) window.open(CreateLinkTo.project(projectId), '_blank');
        else history.push(CreateLinkTo.project(projectId));
    };
    const onDesignerSelected = (designerId: string): void => history.push(CreateLinkTo.designer(designerId));

    const [rawLikes, setRawLikes] = useState(0);
    const [rawIsLiked, setRawIsLiked] = useState(false);

    useEffect(() => {
        if (identifier) {
            LikeAPI.GetLike({ entityId: identifier, entityType: 'project' })
                .then((v) => v.json())
                .then((v) => API.toLang<LikeObject>(v, i18next.language))
                .then((v) => {
                    setRawIsLiked(v.isLike);
                    setRawLikes(v.countLike);
                });
        }
    }, [identifier]);

    return (
        <ProjectCardLayout
            identifier={identifier}
            onClick={onProjectClick}
            img={image}
            isLoading={isLoading}
            width={width}
            height={height}
            href={CreateLinkTo.project(identifier ?? '')}
            // Заголовок карточки
            title={<ProjectCardTitle>{title}</ProjectCardTitle>}
            isMoreVisible={isEditable}
            more={
                <ProjectCardTools
                    {...handlers}
                    isHiddenCancel={true}
                    isCanBeDraft={true}
                    identifier={identifier}
                    isEditable={true}
                    isCopyLink={true}
                    onCopyLink={createCopyLinkProjectFn(toasts, t)}
                    {...(tooltip ?? {})}
                />
            }
            // Отображение одного и множественных авторов
            author={
                <FInter.SmallText color={Colors.geoWhite47}>
                    <ProjectDesignerName value={author ? [author].concat(coAuthors ?? []) : (coAuthors ?? [])} onSelected={onDesignerSelected} />
                </FInter.SmallText>
            }
            // Лайки, но только отображение
            likes={<LikesBox likes={rawLikes} isLiked={rawIsLiked} isInteractive={false} />}
        />
    );
};
